export const widgetMainDocument =
  (process.env.REACT_APP_CONTAINER_WRAPPER_ELEMENT_ID &&
    document.getElementById(process.env.REACT_APP_CONTAINER_WRAPPER_ELEMENT_ID)?.shadowRoot) ||
  document;
